import { updateMultiFacet } from "../../store/actionCreators";
import { clearRangeFacet } from "../../priceRange/thunks";
import { getVisibleFacets } from "../../../selectors";
import { isFacetPriceRange } from "../../priceRange/selectors";
import { isLargeMediumViewPort } from "../../ui/helpers/viewportHelper";
import applyFacets from "./apply";
import {
  analyticsClearRefinement,
  analyticsPendingClearRefinement
} from "../../../../analytics/actions";

export default function clear(facetId) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedFacets = getVisibleFacets(state);
    const facet = selectedFacets.find(facet => facet.id === facetId);

    if (facet) {
      const selectedFacetValues = facet.facetValues.filter(
        facetValue => facetValue.isSelected
      );

      const facetsToUnselect = selectedFacetValues.map(facetValue => ({
        facetId,
        valueId: facetValue.id,
        isSelected: false
      }));

      dispatch(updateMultiFacet(facetsToUnselect, { skipDebounce: true }));

      if (isLargeMediumViewPort(state)) {
        dispatch(
          analyticsPendingClearRefinement({
            facet,
            clearedFacetValues: selectedFacetValues
          })
        );
        if (isFacetPriceRange({ id: facetId })) {
          dispatch(clearRangeFacet());
        }
        dispatch(applyFacets());
      } else {
        dispatch(
          analyticsClearRefinement({
            facet,
            clearedFacetValues: selectedFacetValues
          })
        );
        if (isFacetPriceRange({ id: facetId })) {
          dispatch(clearRangeFacet());
        }
      }
    }
  };
}
